import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {IElementLine} from '../../../../incase-domain/elements/shapes/line';
import NumberInput from '../../../../ui/components/NumberInput';
import FontAndBackgroundColorPicker, {COLOR_FIELDS} from '../common/fontAndBackgroundColorPicker';
import SlideChange from '../common/slideChange';
import {TABS} from '../../form/part/tabs';
import AnimationForm from '../common/animationForm';
import {useHighlightedElement, useSetHighlightedElement} from '../../../../utils/hooks/slideUpdates/useSetSlideElement';

interface HighlightedLineElementComponentProps {
    activeTab: string;
}
function HighlightedLineElementComponent(props: HighlightedLineElementComponentProps): ReactElement {
    const {activeTab} = props;
    const {t} = useTranslation();
    const highlightedElement = useHighlightedElement() as IElementLine;
    const updateHighlightedElement = useSetHighlightedElement();

    if (activeTab === TABS.STYLE.id) {
        return (
            <>
                <div className="l-group--form">
                    <div className="l-group__item u-flex u-flex-col u-gap-2">
                        <NumberInput
                            label={t('designSidepanel.lineThickness')}
                            step={0.1}
                            min={0.1}
                            value={highlightedElement.size || 0.1}
                            onChange={(newValue) => {
                                updateHighlightedElement.single('size', newValue || 1);
                            }}
                        />
                        <FontAndBackgroundColorPicker
                            highlightedElement={highlightedElement}
                            highlightedElementChangeHandler={updateHighlightedElement}
                            colorFields={[COLOR_FIELDS.BACKGROUND_COLOR]}
                            placeholder={t('designSidepanel.lineColor')}
                        />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <AnimationForm
                appearAfter={highlightedElement.appearAfter || 0}
                elementAnimations={highlightedElement.elementAnimations}
                highlightedElementChangeHandler={updateHighlightedElement}
            />
            <div className="l-group--form">
                <SlideChange
                    slideChange={highlightedElement.slideChange}
                    setSlideChange={(slideChange) => {
                        updateHighlightedElement.single('slideChange', slideChange);
                    }}
                />
            </div>
        </>
    );
}

export default HighlightedLineElementComponent;
